export const CARDS_CACHE_KEY = 'yugiohdrafter.com-cards'